<template>
    <div class="order-reports-page">
        <div class="container-fluid pt-3">

        <h1>{{ t('places-usage_report-title') }}</h1>
        <filter-bar
            @changed="loadData"
            ref="filterBar"
            :has-branch-filter="false"
        />
        <div class="clear"></div>
        <loader v-if="is('loading')"></loader>
        <div v-if="is('success')">
            <div class="box">
                <h2>{{ t('places-usage_report-general') }}</h2>
                <table class="table table-responsive">
                    <thead>
                        <tr>
                            <td>{{ t('places-usage_report-establishment') }}</td>
                            <td>{{ t('places-usage_report-orders') }}</td>
                            <td>{{ t('places-usage_report-total_income') }}</td>
                            <td>{{ t('places-usage_report-new_clients') }}</td>
                            <td>{{ t('places-usage_report-sign_ups') }}</td>
                            <td>{{ t('places-usage_report-sign_up_rate') }}</td>
                            <td>{{ t('places-usage_report-used_coupons') }}</td>
                            <td>{{ t('places-usage_report-used_rewards') }}</td>
                        </tr>
                    </thead>
                    <tr v-for="(metrics, place) in placesResult" :key="place">
                        <td>{{ place }}</td>
                        <td>{{ metrics.orders }}</td>
                        <td>{{ metrics.totalIncome }}</td>
                        <td>{{ metrics.newClients }}</td>
                        <td>{{ metrics.signUps }}</td>
                        <td>
                            {{
                                metrics.newClients > 0
                                    ? formatNumber(
                                          (metrics.signUps * 100) /
                                              metrics.newClients,
                                      )
                                    : 0
                            }}
                        </td>
                        <td>{{ metrics.usedCoupons }}</td>
                        <td>{{ metrics.usedRewards }}</td>
                    </tr>
                </table>
            </div>
            <div v-for="(dates, place) in report" class="box" :key="place">
                <h2>{{ place }}</h2>
                <table class="table table-responsive">
                    <thead>
                        <tr>
                            <td>{{ t('places-usage_report-date') }}</td>
                            <td>{{ t('places-usage_report-orders') }}</td>
                            <td>{{ t('places-usage_report-total_income') }}</td>
                            <td>{{ t('places-usage_report-new_clients') }}</td>
                            <td>{{ t('places-usage_report-sign_ups') }}</td>
                            <td>{{ t('places-usage_report-sign_up_rate') }}</td>
                            <td>{{ t('places-usage_report-used_coupons') }}</td>
                            <td>{{ t('places-usage_report-used_rewards') }}</td>
                        </tr>
                    </thead>
                    <tr v-for="(metrics, date) in dates" :key="date">
                        <td>
                            <human-date
                                :date="date"
                                format="[d]/[M]/[Y] ([D])"
                            />
                        </td>
                        <td>{{ metrics.orders }}</td>
                        <td>{{ metrics.totalIncome }}</td>
                        <td>{{ metrics.newClients }}</td>
                        <td>{{ metrics.signUps }}</td>
                        <td>
                            {{
                                metrics.newClients > 0
                                    ? formatNumber(
                                          (metrics.signUps * 100) /
                                              metrics.newClients,
                                      )
                                    : 0
                            }}
                        </td>
                        <td>{{ metrics.usedCoupons }}</td>
                        <td>{{ metrics.usedRewards }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="is('empty')">
            <span
                class="alert alert-info"
                style="margin-bottom: 10px; display: inline-block"
            >
                {{ t('places-usage_report-empty') }}
            </span>
        </div>
    </div>
</div>
</template>
<style lang="less">
.page-content.orders-report {
    max-width: 100%;
}
</style>
<script>
import FilterBar from "../../components/reports/filter-bar";
import keviApi from "../../keviApi";
import BarChart from "../../components/charts/barChart";

export default {
    props: {
        user: Object,
    },
    components: {
        FilterBar,
        BarChart,
    },
    data: () => ({
        filters: {},
        report: {},
        placesResult: {},
        status: "loading",
    }),
    mounted() {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi | " + this.t("places-usage_report-title");
        this.$refs.filterBar.addFilter("period");
    },
    computed: {},
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        setState(status) {
            this.status = status;
        },
        is(status) {
            return this.status === status;
        },
        loadData(filters) {
            this.filters = filters;
            this.setState("loading");
            const options = keviApi.getOptions("place/usage-reports", "GET", {
                filters: filters,
            });
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.setState("success");
                    this.report = response.body.report;
                    this.placesResult = response.body.placesResult;
                }
            });
        },
        formatNumber(number) {
            return parseFloat(number).toLocaleString("pt-BR");
        },
    },
};
</script>
